export default __webpack_public_path__ + "static/media/Robot.d38d107f.jpg";